<template>
  <base-layout
    page-default-back-link="/login"
    showUserSettings="true"
    showSettings="true"
  >
    <h1 class="heading-h2 ion-text-center">
      Welcome to Leon Visitor System<br />
      <small>Please select an Action</small>
    </h1>
    <div class="lg-content-center">
      <ion-grid>
        <ion-row>
          <ion-col
            size="auto"
            class="menu-column"
            @click="gotoPage('/newvisit')"
          >
            <div class="menu-inner">
              <div class="menu-icon">
                <ion-icon :icon="add"></ion-icon>
              </div>
              <ion-label>
                <h2>New Visit</h2>
              </ion-label>
              <ion-label>
                <p>Start a new visit</p>
              </ion-label>
            </div>
          </ion-col>

          <ion-col size="auto" class="menu-column" @click="gotoPage('/scan')">
            <div class="menu-inner">
              <div class="menu-icon">
                <ion-icon :icon="qrCodeOutline"></ion-icon>
              </div>
              <ion-label>
                <h2>Scan</h2>
              </ion-label>
              <ion-label>
                <p>Scan and Inspect</p>
              </ion-label>
            </div>
          </ion-col>

          <ion-col size="auto" class="menu-column" @click="gotoPage('/visits')">
            <div class="menu-inner">
              <div class="menu-icon">
                <ion-icon :icon="document"></ion-icon>
              </div>
              <ion-label>
                <h2>Visits</h2>
              </ion-label>
              <ion-label>
                <p>Manage Visits</p>
              </ion-label>
            </div>
          </ion-col>

          <ion-col
            size="auto"
            class="menu-column"
            @click="gotoPage('/customers')"
          >
            <div class="menu-inner">
              <div class="menu-icon">
                <ion-icon :icon="accessibility"></ion-icon>
              </div>
              <ion-label>
                <h2>Visitors</h2>
              </ion-label>
              <ion-label>
                <p>Customers and visitors</p>
              </ion-label>
            </div>
          </ion-col>

          <ion-col
            size="auto"
            class="menu-column"
            @click="gotoPage('/products')"
          >
            <div class="menu-inner">
              <div class="menu-icon">
                <ion-icon :icon="pricetags"></ion-icon>
              </div>
              <ion-label>
                <h2>Products</h2>
              </ion-label>
              <ion-label>
                <p>Search for Products</p>
              </ion-label>
            </div>
          </ion-col>

          <ion-col
            size="auto"
            class="menu-column"
            @click="gotoPage('/inventory')"
          >
            <div class="menu-inner">
              <div class="menu-icon">
                <ion-icon :icon="location"></ion-icon>
              </div>
              <ion-label>
                <h2>Inventory</h2>
              </ion-label>
              <ion-label>
                <p>Search for Floor Samples</p>
              </ion-label>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </base-layout>
</template>

<script>
import { IonCol, IonGrid, IonRow, IonIcon } from "@ionic/vue";
import {
  add,
  document,
  accessibility,
  pricetags,
  location,
  qrCodeOutline,
} from "ionicons/icons";

export default {
  components: { IonCol, IonGrid, IonRow, IonIcon },

  data() {
    return {
      add,
      document,
      accessibility,
      pricetags,
      location,
      qrCodeOutline
    };
  },
  methods: {
    gotoPage(page) {
      if(page=='/products')
        this.$router.push({ name:'Products', params:{ pitem_id:0 }})
      else if(page=='/scan')
        this.$router.push({ name:'Scan', params:{ open_scan:1 }})
      else
        this.$router.push(page);
    },
  }
};
</script>

<style lang="scss" scoped>
h2 {
  font-weight: 600;
  color: #000000;
}

ion-col.menu-column {
  width: 50% !important;
  min-height: 25vh;
}

.menu-inner {
  background: #fff;
  border: 1px solid #efefef;
  width: 100% !important;
  padding: 1em;
  min-height: 20vh;
}

.menu-inner ion-label {
  display: block;
  padding-top: 1.5vh;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
}

.menu-inner .menu-icon {
  text-align: center;
  padding: 10px;

  ion-icon {
    color: #333;
    font-size: 5vh;
  }
}

ion-item {
  --background: #ffffff;
  margin: 5px 0 0 -15px;
  line-height: 50px;
  border-radius: 5px;
}
</style>